import { Dialog, DialogContent, DialogContentText, Grid } from '@material-ui/core';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import membrosFamiliaIcon from '../../assets/img/membros-familia-icon.svg';
import auth from '../../auth/Auth';
import { authLogout, selectGovBr } from '../../auth/authSlice';
import { currencyFormat, formatarNumeroFamiliar } from '../../common/formatadores';
import BotaoConsulta from '../../components/BotaoConsulta/BotaoConsulta';
import Card from '../../components/Card/Card';
import FieldGroup from '../../components/FieldGroup/FieldGroup';
import MainContainer from '../../components/MainContainer/MainContainer';
import { selectLogado } from '../IdentificacaoPositiva/identificacaoPositivaSlice';
import { getPerfis , getPermiteRemoverFamiliaCadUnico, selectPerfilCompleto, selectPermiteRemoverFamiliaCadUnico, selectSituacaoCadastroFamilia } from '../Perfil/perfilSlice';
import CaracteristicasDomicilio from './components/CaracteristicasDomicilio/CaracteristicasDomicilio';
import DetalhesMembro, { DetalhesView } from './components/DetalhesMembro/DetalhesMembro';
import IdentificacaoEndereco from './components/IdentificacaoEndereco/IdentificacaoEndereco';
import InformacoesFamilia from './components/InformacoesFamilia/InformacoesFamilia';
import MembrosFamiliares from './components/MembrosFamiliares/MembrosFamiliares';
import CarteiraDocumentos from './components/CarteiraDocumentos/CarteiraDocumentos';
import { voltarParaLista } from '../CarteiraDocumentos/carteiraDocumentosSlice';
import styles from './ConsultaCompleta.module.css';
import configuration from '../../envConfig';
import {
  getCaracteristicasDomicilio,
  getDadosRepresentanteLegal,
  getExportacaoConsultaCompleta,
  getIdentificacaoEndereco,
  getInfoFamilia,
  getMembrosFamiliares,
  getMembrosFamiliaresParaVerificacaoSolicitacaoObito,
  getRepresentanteLegal,
  getResponsaveisFamiliares,
  irParaCarteiraDocumentos,
  limparPdf,
  selectFamiliaTemSolicitacaoObito,
  selectPdf,
  selectRepresentanteLegal,
  selectState,
  State,
  voltarParaMembros,
  voltarParaMenu,
  voltarParaMembro,
} from './consultaCompletaSlice';
import { sharePdf } from '../../common/cordovaPluginUtils';
import { base64toObjectURL } from '../../common/converterUtils';
import { TipoPerfil } from '../../model/TipoPerfil';
import { selectInformacaoPeriodoRetornoCadastramento } from '../ConsultaSimples/consultaSimplesSlice';
import { obterNomeDoPerfil } from '../../common/perfilUtils';
import { trackServiceSelect } from '../../common/tracker';

const ConsultaCompleta: React.FC<any> = (props) => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const perfil = useAppSelector(selectPerfilCompleto);
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);
  const state = useAppSelector(selectState);
  const periodoFamiliaCadastramento = useAppSelector(selectInformacaoPeriodoRetornoCadastramento);

  const representanteLegal = useAppSelector(selectRepresentanteLegal);

  const govBrLogado = useAppSelector(selectGovBr).logado;
  const isAuthenticatedIdPositiva = useAppSelector(selectLogado);

  const selectedPdf = useAppSelector(selectPdf);

  const permiteRemoverFamiliaCadUnico = useAppSelector(selectPermiteRemoverFamiliaCadUnico);

  const temSolicitacaoObito: boolean = useAppSelector(selectFamiliaTemSolicitacaoObito);

  const [dialogoExplicacao, setDialogoExplicacao] = useState(false);
  const [dialogoExplicacaoRendaTotal, setDialogoExplicacaoRendaTotal] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(voltarParaMenu());
    };
  }, [dispatch, situacaoCadastroFamilia, history]);

  useEffect(() => {
    const rootEl = document.getElementById('root');
    rootEl?.scrollTo(0, 0);
  }, [state]);

  useEffect(() => {
    if (auth.isAuthenticated() && perfil && perfil.numeroFamiliar && !permiteRemoverFamiliaCadUnico) {
      dispatch(getPermiteRemoverFamiliaCadUnico({cpf: auth.getUser(), numeroFamiliar:perfil.numeroFamiliar }));
    }
  }, [dispatch, perfil])

  useEffect(() => {
    if (selectedPdf) {
      if (configuration.isCordova) {
        sharePdf(`data:application/pdf;ConsultaCompleta${perfil.numeroFamiliar}.pdf;base64,`, selectedPdf);
      } else {
        const fileURL = base64toObjectURL(selectedPdf);
        window.open(fileURL);
      }
      dispatch(limparPdf());
    }

    return () => {
      dispatch(limparPdf());
    };
  }, [selectedPdf]);

  useEffect(() => {
    if (props.location?.state?.mostrarRepresentanteLegal) {
      dispatch(getRepresentanteLegal(perfil.numeroFamiliar));
    }
  }, [dispatch, perfil.numeroFamiliar, props.location?.state?.mostrarRepresentanteLegal]);

  useEffect(() => {
    if (perfil.temRL && !representanteLegal) {
      dispatch(getDadosRepresentanteLegal(perfil.numeroFamiliar));
    }
  }, [dispatch, perfil.temRL, perfil.numeroFamiliar, representanteLegal]);

  useEffect(() => {
    if (props.location?.state?.mostrarIntegrantes) {
      dispatch(getMembrosFamiliares(perfil.numeroFamiliar));
    } else {
      dispatch(getMembrosFamiliaresParaVerificacaoSolicitacaoObito(perfil.numeroFamiliar));
    }
  }, [dispatch, perfil.numeroFamiliar, props.location?.state?.mostrarIntegrantes]);

  const getTitulo = () => {
    switch (state) {
      case State.IDENTIFICACAO_ENDERECO:
        return 'Endereço da família';
      case State.CARACTERISTICAS_DOMICILIO:
        return 'Dados do domicílio';
      case State.INFO_FAMILIA:
        return 'Despesas e outros dados';
      case State.RESPONSAVEL_FAMILIAR:
        return 'Responsável familiar';
      case State.REPRESENTANTE_LEGAL:
        return 'Representante legal';
      case State.MEMBRO_FAMILIAR:
        return 'Integrante familiar';
      case State.MEMBROS_FAMILIARES:
        return 'Integrantes familiares';
      case State.CARTEIRA_DOCUMENTOS:
        return 'Carteira de documentos';
      default:
        return 'Consulta ao formulário';
    }
  };

  const goBack = async () => {
    if (props.location?.state?.origem === '/consultaCompleta') {
      await dispatch(voltarParaMenu())
      return history.replace('/consultaCompleta');
    }

    if (state !== State.MENU) {
      if (state === State.MEMBROS_FAMILIARES && props.location?.state?.mostrarIntegrantes || state === State.REPRESENTANTE_LEGAL && props.location?.state?.mostrarRepresentanteLegal) {
        return history.replace('/home');
      }

      if (state === State.MEMBRO_FAMILIAR) {
        const rootEl = document.getElementById('root');
        rootEl?.scrollTo(0, 0);
        return dispatch(voltarParaMembros());
      }
      if (state === State.CARTEIRA_DOCUMENTOS) {
        const rootEl = document.getElementById('root');
        rootEl?.scrollTo(0, 0);
        dispatch(voltarParaLista());
        return dispatch(voltarParaMembro());
      }
      return dispatch(voltarParaMenu());
    }
    history.replace('/home');
  };

  const caixaMensagens = () => {
    trackServiceSelect('POR-MENU', "CAIXA DE MENSAGEM");
    history.push('/caixa-mensagem');
  };

  const isLogado = () => {
    return (govBrLogado && situacaoCadastroFamilia) || isAuthenticatedIdPositiva
      ? true
      : false;
  }

  const logout = () => {
    dispatch(authLogout({ history }));
  };

  const exportarConsultaCompleta = (numeroFamiliar) => {
    trackServiceSelect('POR-MENU', "EXPORTAR CONSULTA (FORM DO CADASTRO UNICO)");
    const dados = {
      numeroFamiliar,
      cpf: auth.getUser()
    }

    dispatch(getExportacaoConsultaCompleta(dados))
  }

  const mostrarBordaAmarela = () => {
    return indicacaoDeObito() || ehFamiliaCadastradaComIntegranteEmCadastramento();
  };

  const ehFamiliaCadastradaComIntegranteEmCadastramento = () => {
    const temPessoaEmCadastramento = perfil?.integrantesFamilia?.some(elem => elem.estadoCadastralPessoa.id === 1);

    return perfil?.tipoEstadoCadastralFamilia?.codigo === 3 && temPessoaEmCadastramento;
  }

  const indicacaoDeObito = () => {
    return perfil?.integrantesFamilia?.some(elem => !!elem.obito);
  };

  const indicacaoRLDeObito = () => {
    return representanteLegal?.obito;
  };

  // Método criado para a exibição da borda amarela para o indicativo de óbito do RL ficar isolado do indicativo da borda amarela de um integrante familiar,
  // como no método mostrarBordaAmarela, pois, caso contrário, se o método ehFamiliaCadastradaComIntegranteEmCadastramento fosse true o card RL ficaria amarelo.
  const mostrarBordaAmarelaRL = () => {
    return indicacaoRLDeObito();
  };


  const familiaTemSolicitacaoExclusaoObito = (label: string, rendaPerCapita: boolean) => {
    if (temSolicitacaoObito) {
      return <>
      <div>{label}
        <i
          className={`fas fa-exclamation-triangle ${styles.alertIcon}`}
          onClick={() => rendaPerCapita? setDialogoExplicacao(true):setDialogoExplicacaoRendaTotal(true)}
        />
      </div>
    </>
    };

    return <>{label}</>
  };


  const telaPrincipal = (
    <>
      <div className={styles.cardHeader}>
        <i className={`fas fa-address-book ${styles.cardIcon}`}></i>
        <span className={styles.cardHeaderTitle}>Dados da família</span>
      </div>

      <Card>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FieldGroup
              label="Código familiar"
              value={formatarNumeroFamiliar(perfil?.numeroFamiliar)}
            />
          </Grid>
          <Grid item xs={6}>
            <FieldGroup
              label="Estado cadastral"
              value={perfil?.tipoEstadoCadastralFamilia?.nome}
            />
          </Grid>
          <Grid item xs={12}>
            <FieldGroup
              label="Local do cadastro"
              value={perfil?.municipio ? perfil?.municipio + ' - ' + perfil?.uf : '-'}
            />
          </Grid>
          <Grid item xs={6}>
            <FieldGroup
              label="Data do cadastro"
              value={
                perfil?.dataCadastroFamilia
                  ? moment(perfil?.dataCadastroFamilia).format('DD/MM/YYYY')
                  : null
              }
            />
          </Grid>
          <Grid item xs={6}>
            <FieldGroup
              label="Última atualização"
              value={periodoFamiliaCadastramento ? '-' :
                perfil?.dataAtualizacaoFamilia
                  ? moment(perfil?.dataAtualizacaoFamilia).format('DD/MM/YYYY')
                  : null
              }
            />
          </Grid>
          <Grid item xs={12}>
            <FieldGroup
              label={familiaTemSolicitacaoExclusaoObito("Renda familiar total",false)}
              value={
                perfil?.rendaFamiliarTotal
                  ? currencyFormat(perfil?.rendaFamiliarTotal)
                  : currencyFormat(0)
              }
            />
          </Grid>
          <Grid item xs={12}>
            <FieldGroup
              label={familiaTemSolicitacaoExclusaoObito("Renda familiar por pessoa (per capita)",true) }
              value={
                perfil?.rendaFamiliarPorPessoa
                  ? currencyFormat(perfil?.rendaFamiliarPorPessoa)
                  : currencyFormat(0)
              }
            />
          </Grid>
        </Grid>
      </Card>

      <div className={styles.buttonGridWrapper}>
        <Grid container spacing={2}>
          <Grid item xs={4} sm={2}>
            <BotaoConsulta
              iconClass="fa-map-marker-alt"
              text="Endereço da família"
              onClick={() => dispatch(getIdentificacaoEndereco(perfil.numeroFamiliar))}
            />
          </Grid>
          {(!perfil?.familiaEmSituacaoDeRua ||
            perfil?.familiaEmSituacaoDeRua.codigo !== 1) && (
            <Grid item xs={4} sm={2}>
              <BotaoConsulta
                iconClass="fa-home"
                text="Dados do domicílio"
                onClick={() => dispatch(getCaracteristicasDomicilio(perfil.numeroFamiliar))}
              />
            </Grid>
          )}
          <Grid item xs={4} sm={2}>
            <BotaoConsulta
              iconClass="fa-file-invoice-dollar"
              text="Despesas e outros dados"
              onClick={() => dispatch(getInfoFamilia(perfil.numeroFamiliar))}
            />
          </Grid>
          <Grid item xs={4} sm={2}>
            <BotaoConsulta
              className={mostrarBordaAmarela() ? styles.buttonBorderAlert : ""}
              img={membrosFamiliaIcon}
              text="Integrantes familiares"
              onClick={() => dispatch(getMembrosFamiliares(perfil.numeroFamiliar))}
            />
          </Grid>
          {perfil && perfil.temRF && (
            <Grid item xs={4} sm={2}>
              <BotaoConsulta
                iconClass="fa-id-card-alt"
                text="Responsável familiar"
                onClick={() => dispatch(getResponsaveisFamiliares(perfil.numeroFamiliar))}
              />
            </Grid>
          )}
          {perfil && perfil.temRL && (
            <Grid item xs={4} sm={2}>
              <BotaoConsulta
                className={mostrarBordaAmarelaRL() ? styles.buttonBorderAlert : ""}
                iconClass="fa-user-tie"
                text="Representante legal"
                onClick={() => dispatch(getRepresentanteLegal(perfil.numeroFamiliar))}
              />
            </Grid>
          )}
          {perfil && (perfil.tipoPerfil.codigo === TipoPerfil.RESPONSAVEL_FAMILIAR || perfil.tipoPerfil.codigo === TipoPerfil.REPRESENTANTE_LEGAL) && (
            <Grid item xs={4} sm={2}>
              <BotaoConsulta
                iconClass="fa-file-download"
                text="Exportar consulta"
                onClick={() => exportarConsultaCompleta(perfil.numeroFamiliar)}
              />
            </Grid>
          )}
        </Grid>
      </div>
    </>
  );

  return (
    <MainContainer
      userNav={isLogado()}
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      titleBarraAuxiliar={getTitulo()}
      barraAuxiliar={true}
      stoppedTitle={true}
      navFixed
      navGoBack={goBack}
      navSeparator
      navCaixaMensagens={isLogado() ? caixaMensagens : undefined}
      navLogout={isLogado() ? logout : undefined}>
      <div className={styles.container}>
        {state === State.MENU && telaPrincipal}
        {state === State.IDENTIFICACAO_ENDERECO && <IdentificacaoEndereco />}
        {state === State.CARACTERISTICAS_DOMICILIO && <CaracteristicasDomicilio />}
        {state === State.INFO_FAMILIA && <InformacoesFamilia styles={styles} />}
        {state === State.RESPONSAVEL_FAMILIAR && (
          <DetalhesMembro styles={styles} view={DetalhesView.RESPONSAVEL} />
        )}
        {state === State.REPRESENTANTE_LEGAL && (
          <DetalhesMembro styles={styles} view={DetalhesView.REPRESENTANTE_LEGAL} />
        )}
        {state === State.MEMBRO_FAMILIAR && (
          <DetalhesMembro styles={styles} view={DetalhesView.MEMBRO} />
        )}
        {state === State.MEMBROS_FAMILIARES && <MembrosFamiliares {...props} />}
        {state === State.CARTEIRA_DOCUMENTOS && <CarteiraDocumentos />}

        <Dialog
          open={dialogoExplicacao}
          onClick={() => setDialogoExplicacao(false)}
          onClose={() => setDialogoExplicacao(false)}
        >
          <DialogContent>
            <DialogContentText>
              <span className={styles.textoDialogo}>
                <b>Identificada a exclusão de integrante familiar. O valor da renda familiar por pessoa poderá ser reajustado. Aguardar 1 dia útil para nova conferência.</b>
              </span>
            </DialogContentText>
          </DialogContent>
        </Dialog>

        <Dialog
          open={dialogoExplicacaoRendaTotal}
          onClick={() => setDialogoExplicacaoRendaTotal(false)}
          onClose={() => setDialogoExplicacaoRendaTotal(false)}
        >
          <DialogContent>
            <DialogContentText>
              <span className={styles.textoDialogo}>
                <b>Identificada a exclusão de integrante familiar. O valor da renda familiar total poderá ser reajustado. Aguardar 1 dia útil para nova conferência.</b>
              </span>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </div>
    </MainContainer>
  );
};

export default ConsultaCompleta;
